import React from "react";
import { FaLinkedinIn, FaYoutube } from "react-icons/fa6";
import { usePublicLang } from "../../../../config/i18n/public";

const BRAND_ICONS = {
  linkedin: FaLinkedinIn,
  youtube: FaYoutube,
};

export default function ContactFooterLinks({ brand, columns }) {
  const { lang } = usePublicLang();
  const sealSrc = `https://api.heydata.eu/privacy-seal/seal/d9b40c59-e746-4d34-8c60-fdc465b2cf5a?lang=${
    lang === "en" ? "en" : "de"
  }&design=design1&sealType=GDPR`;

  return (
    <div className="mt-[1.65rem] grid grid-cols-[minmax(0,1fr)_auto] gap-[2.2rem] py-[0.55rem] pb-[1.55rem] md:grid-cols-[minmax(0,1.12fr)_minmax(148px,0.62fr)_minmax(0,0.8fr)_minmax(0,0.8fr)]">
      <div className="min-w-0 flex flex-col gap-6">
        <div>
          <h3 className="m-0 text-[0.88rem] font-bold uppercase tracking-[0.12em] text-white">
            {brand.title}
          </h3>
          <p className="mt-4 max-w-[17rem] text-[0.92rem] leading-[1.7] text-[rgba(213,220,232,0.62)]">
            {brand.description}
          </p>
        </div>

        <div className="mt-0 flex gap-[0.75rem] md:mt-4">
          {brand.socialLinks.map((link) => {
            const Icon = BRAND_ICONS[link.icon] ?? FaLinkedinIn;

            return (
              <a
                key={link.label}
                href={link.href}
                className="inline-flex h-[2.55rem] w-[2.55rem] items-center justify-center rounded-full bg-[rgba(255,255,255,0.05)] text-[#edf2ff] no-underline transition duration-200 hover:-translate-y-px hover:bg-[rgba(112,136,255,0.22)]"
                aria-label={link.label}
                target="_blank"
                rel="noreferrer noopener"
              >
                <Icon />
              </a>
            );
          })}
        </div>
      </div>

      <div className="flex items-start justify-start md:-ml-20 md:justify-start md:pt-[2px]">
        <a
          href="https://heydata.eu"
          target="_blank"
          rel="noreferrer"
          title="heyData GDPR seal"
          className="inline-flex"
        >
          <img
            alt="heyData trusted logo"
            src={sealSrc}
            className="block h-[172px] w-[172px] border-0"
            loading="lazy"
          />
        </a>
      </div>

      {columns.map((column) => (
        <div key={column.title} className="col-span-2 md:col-span-1">
          <h4 className="m-0 text-[0.88rem] font-bold uppercase tracking-[0.12em] text-white">
            {column.title}
          </h4>
          {column.links ? (
            <ul className="mt-4 grid list-none gap-[0.65rem] p-0">
              {column.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-[0.95rem] leading-[1.65] text-[rgba(233,238,247,0.76)] no-underline transition hover:text-white"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            <ul className="mt-4 grid list-none gap-[0.65rem] p-0">
              {column.lines.map((line) => (
                <li key={line} className="text-[0.95rem] leading-[1.65] text-[rgba(233,238,247,0.76)]">
                  {line}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}
